module.exports = __webpack_public_path__ + "img/40800.595c4106.jpg";